// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2vt3t","selected":"Chip_selected__58xAl"};